export { default as FundsOverviewCard } from "./FundsOverviewCard";
export type { FundsCardProps } from "./FundsOverviewCard";
